import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Supabase URL and Anon Key must be provided');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type Profile = {
  id: string;
  name: string;
  kana: string;
  email: string;
  phone: string;
  address?: string;
  created_at: string;
  updated_at: string;
};

export type PrayerReservation = {
  id: string;
  user_id: string;
  name: string;
  kana: string;
  email: string;
  phone: string;
  prayer_date: string;
  prayer_time: string;
  prayer_type: string;
  participants: number;
  address?: string;
  father_name?: string;
  mother_name?: string;
  husband_name?: string;
  husband_kana?: string;
  child_name?: string;
  child_age?: string;
  child_gender?: string;
  message?: string;
  status: 'pending' | 'confirmed' | 'cancelled';
  created_at: string;
  updated_at: string;
};
